import React, { ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Divider, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

type ViewSectionProps = {
    button?: ReactNode;
    icon: IconDefinition;
    title: string;
};

const ViewSection: React.FC<ViewSectionProps> = ({ button, icon, title, children }) => {
    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                    gap: 1,
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <FontAwesomeIcon icon={icon} size="2x" />
                    <Typography variant="h6">
                        <FormattedMessage id={title} />
                    </Typography>
                </Box>
                {button}
            </Box>
            <Divider
                sx={{ width: "90%", mb: 2, ml: 0, mr: "auto", bgcolor: "primary.main", opacity: 0.7, heigth: 2 }}
            />
            {children}
        </Box>
    );
};

export default ViewSection;
